import { Alert, Icon, Stack, TextField, Typography } from '@mui/material'
import SimpleCard from '../../../../../../components/Cards/SimpleCard'
import NumberFunctions from '../../../../../../core/functions/NumberFunctions'
import { maskMoney } from '../../../../../../masks/masks'
import { grey } from '@mui/material/colors'
import ErrorSnackbar from '../../../../../../components/Snackbar/ErrorSnackbar'
import { UserSettingExtractTransferDataProps } from './UserSettingExtractTransferTypes'

const UserSettingExtractTransferData = ({
  data,
  sending,
  value,
  setValue,
  error,
  setError,
  isErrorWithdrawValue,
  getAmountValue,
}: UserSettingExtractTransferDataProps) => {
  return (
    <Stack direction="column" width="100%" spacing={2} sx={{ py: 1 }}>
      <SimpleCard
        sx={{
          px: 2,
          mb: 2,
          backgroundColor: '#F2F2FF',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <Icon
          sx={{
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'center',
            justifyContent: 'center',
          }}
        >
          <img src="/assets/icons/money/moneyIcon.svg" alt="money" />
        </Icon>
        <Stack flexDirection="column">
          <Typography variant="caption" color="#707275">
            Valor calculado para transferência
          </Typography>
          <Typography
            variant="h5"
            color={(theme) => theme.palette.grey[900]}
            fontWeight={500}
          >
            {NumberFunctions.formatMoneyDefault(data?.value ?? 0)}
          </Typography>
        </Stack>
      </SimpleCard>
      <Stack direction="column" spacing={0}>
        <TextField
          fullWidth
          variant="outlined"
          label="Valor do crédito a transferir"
          focused
          disabled={sending}
          value={maskMoney(value)}
          onChange={(e) => {
            const valueValid = maskMoney(e.target.value)
              .replaceAll('.', '')
              .replaceAll(',', '.')
            setValue(valueValid)
          }}
          error={isErrorWithdrawValue()}
        />
        <Typography variant="caption">
          Informe o valor a ser creditado ao usuário.
        </Typography>
        <Typography variant="caption">
          Valor mínimo de {NumberFunctions.formatMoneyDefault(5)}.
        </Typography>
      </Stack>
      <Alert
        severity="warning"
        sx={{ color: '#707275', backgroundColor: '#FBF3E2' }}
      >
        Cobramos uma taxa de <strong>1%</strong> por transação em PIX
      </Alert>
      <SimpleCard
        sx={{
          px: 0,
          mt: 2,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="caption"
          color={grey[600]}
          fontWeight={500}
          fontSize="14px"
          lineHeight="14px"
        >
          Valor bruto a transferir
        </Typography>
        <Typography
          variant="h5"
          color={grey[900]}
          fontWeight={600}
          fontSize="20px"
          lineHeight="28px"
        >
          {NumberFunctions.formatMoneyDefault(getAmountValue())}
        </Typography>
      </SimpleCard>

      <ErrorSnackbar open={error !== ''} onClose={() => setError('')}>
        {error}
      </ErrorSnackbar>
    </Stack>
  )
}

export default UserSettingExtractTransferData
